import React, { useState, useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import axios from 'axios';
import '../styles/Contact.css';

const Contact = () => {
  const { translations } = useContext(LanguageContext)

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'Business Collaboration', // Default subject
    customSubject: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    customSubject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Reset the error when the user types
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubjectChange = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      subject: value,
      customSubject: value === 'Other' ? formData.customSubject : '',
    });
  };

  const validateForm = () => {
    let formIsValid = true;
    let newErrors = { name: '', email: '', customSubject: '', message: '' };

    if (!formData.name.trim()) {
      newErrors.name = translations.contact.errors.nameError;
      formIsValid = false;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@(gmail\.com|abv\.bg|yahoo\.com)$/;

    if (!formData.email.trim()) {
      newErrors.email = translations.contact.errors.emailError;
      formIsValid = false;
    } else if (!emailRegex.test(formData.email)) { // !/\S+@\S+\.\S+/
      newErrors.email = translations.contact.errors.invalidEmailError;
      formIsValid = false;
    }

     // Validate the subject field
    if (formData.subject === 'Other' && !formData.customSubject.trim()) {
      newErrors.customSubject = translations.contact.errors.subjectError;
      formIsValid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = translations.contact.errors.messageError;
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const finalFormData = {
        ...formData,
        subject: formData.subject === 'Other' ? formData.customSubject : formData.subject,
      };

      alert(translations.contact.alerts.waitMessage);

      try {
        const response = await axios({
          method: 'POST',
          url: 'https://rokyuto-1.onrender.com/api/send-email',
          headers: {
            'Content-Type': 'application/json',
          },
          data: finalFormData,
        });

        if (response.status === 200) {
          alert(translations.contact.alerts.successfulMessage) 
          // Clear the form
          setFormData({
            name: '',
            email: '',
            subject: 'Business Collaboration',
            customSubject: '',
            message: ''
          });
        } else {
          alert(translations.contact.alerts.unsuccessfullMessage) 
        }
      } catch (error) {
        console.error('Error:', error);
        alert(translations.contact.alerts.errorMessage);
      }
    }
  };

  return (
    <div className="contact-form-container">
      <form onSubmit={handleSubmit} className="contact-form">
        <h1>{ translations.contact.title }</h1>
        <div className="form-group">
          <label htmlFor="name">{ translations.contact.name }</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            autoComplete="off"
            className={errors.name ? 'error' : ''}
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="email">{ translations.contact.email }</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            autoComplete="off"
            className={errors.email ? 'error' : ''}
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="subject">{ translations.contact.subject }</label>
          <select
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleSubjectChange}
            className="custom-select"
          >
            <option value="Business Collaboration">{ translations.contact.subject_business }</option>
            <option value="Consultation">{ translations.contact.subject_consulatation }</option>
            <option value="Other">{ translations.contact.subject_other }</option>
          </select>
          {formData.subject === 'Other' && (
            <>
              <input
                type="text"
                id="customSubject"
                name="customSubject"
                value={formData.customSubject}
                onChange={handleChange}
                placeholder={ translations.contact.subject_placeholder }
                autoComplete="off"
                className="custom-subject-input"
              />
              {errors.customSubject && <span className="error-message">{errors.customSubject}</span>}
            </>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="message">{ translations.contact.message }</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            autoComplete="off"
            className={errors.message ? 'error' : ''}
          ></textarea>
          {errors.message && <span className="error-message">{errors.message}</span>}
        </div>

        <button type="submit" className="submit-btn">{ translations.contact.buttonText }</button>
      </form>
    </div>
  );
};

export default Contact;
